export default __webpack_public_path__ + "static/media/mobile.4f2dd3be.png";